import { AdminContractDetailPage } from "@/pages/admin-contract-detail";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/admin/contracts/$id/")({
  component: () => {
    const { id } = useParams({ strict: false });
    return <AdminContractDetailPage contractId={id || ""} />;
  },
});
